// import { Autocomplete, Button, Grid, TextField, Typography } from "@mui/material";
// import axios from "axios";
// import React, { Fragment, memo, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useStyle } from "../style";
// import dayjs from "dayjs";
// import _ from "lodash";
// import CustomTable from "../customTable";
// import moment from "moment";
// import { Helmet } from "react-helmet-async";
// import { CSVLink } from "react-csv";
// import Loader from "../../../../../components/loader/loader";

// const SalesPerformance = () => {
//   const classes = useStyle()
//   const dispatch = useDispatch();
//   const pageOption = [10, 25, 50, 100];
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(100);
//   // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//   const [pageCount, setPageCount] = useState(0);
//   const [data, setData] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const roleId = localStorage.getItem("role_id")
//   const outletName = localStorage.getItem('outlet_name')
//   const[cust, setCust] = useState(null)
//   const outletId = localStorage.getItem('outlet_id')
//   const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
//     const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
//     const [loading , setLoading] = useState(false)
//   const [dateLimit, setDateLimit] = useState({
//     // fromDate : roleId != 1 && roleId != 2 ? moment().format() : moment().startOf('month').format(),
    
//     fromDate :  moment().startOf('month').format(),
//     toDate : moment().format()
//   })
//     const [salesManData, setSalesManData] = useState([]);
//     const [custSalesMan, setCustSalesMan] = useState(null);
//   const [filters, setFilters] = useState({
//     price_from: '',
//     price_to: '',
//   });
//   const fixedOutlet = { id: outletId, fullname: outletName };
// const columns = [
//   {
//     field : 'sno',
//     headerName : 'S.no',
//     minWidth : 70,
//     maxWidth : 100,
//     headerAlign : 'center',
//     align : 'center',
//     sortable: false
//   },
// //   {
// //     field: "date1",
// //     headerName: "Date",
// //     flex: 1,
// //     headerAlign: "center",
// //     align: "center",
// //     sortable: false,
// //   },
//   {
//     field: "code",
//     headerName: "code",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "short_name",
//     headerName: "Short Name",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "fullname",
//     headerName: "Outlet",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "sales_man_name",
//     headerName: "Sales Man Name",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "sales_man_code",
//     headerName: "Sales Man Code",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "prodid",
//     headerName: "Prod id",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
// {
//     field: "pro_name",
//     headerName: " Product Name",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
// {
//     field: "count",
//     headerName: " Count",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
// {
//     field: "rate",
//     headerName: "Rate",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
// {
//     field: "total",
//     headerName: "Total",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },


 
// ]

// const rows = _.map(data,(val,idx)=>({
//   id: idx+1,
//   sno: idx+1,
// //   date1 : moment(val.docdate).format('DD-MM-YYYY'),
//   code : val.code,
//   fullname : val.fullname,
//   short_name:val.short_name || "-",
//   sales_man_name : val.sales_man_name || "-",
//   sales_man_code: val.sales_man_code,
//   prodid: val.prodid,
//   pro_name: val.pro_name,
//   count: val.count,
//    rate: val.rate,
//     total: val.total,

// }))
// const props = {
//   columns : columns,
//   rows : rows,
//   page: page,
//   setPage: setPage,
//   rowsPerPage: rowsPerPage,
//   setRowsPerPage: setRowsPerPage,
//   pageCount: pageCount,
//   pageOption: pageOption,
//   totalAmount:totalAmount,
//   totalFlag:totalFlag,
//   loading: loading
// }
// console.log(cust)
//   const getSalesMan = (outletId) => {
//     let endpoint = outletId && outletId !== 0 ? `/v1/SalesMan/outlets/${outletId}` : `/v1/SalesMan`; // Adjust for "All"
//     axios
//       .get(endpoint)
//       .then((res) => {
//         const salesmen = res.data;
//         setSalesManData([{ id: 0, sales_man_name: "" }, ...salesmen]); // Add "All" option
//       })
//       .catch((err) =>
//         dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching salesmen"))
//       );
//   };
// useEffect(() => {
//   // Calculate total balance amount
//   setTotalFlag(true)
//   let total = 0;

//   data.forEach(val => {
//       total += parseFloat(val.total);
//   });
//   setTotalAmount(total.toFixed(0));
// }, [data]);
//   function handleChange(e, name) {
//     setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
//   }
// function handlePaymentReport(){
// //   const postData = {
// //     from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
// //     to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
// //     outlet_id:cust!==null ? cust.id : fixedOutlet.id,
// //     salesman_id: custSalesMan?.id || 0,
// //   }
//   const postData = {
//   from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
//   to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
//   outlet_id: cust !== null ? cust.id : fixedOutlet.id,
//   ...(custSalesMan?.id && { salesman_id: custSalesMan.id }) ,// only adds if exists
//   ...(filters.price_from && { price_from: filters.price_from }),
//     ...(filters.price_to && { price_to: filters.price_to }),
// };

//   console.log(postData)
//   axios.post(`/v1/reports/sales/performance`, postData)
//   .then(res=>{
//     setData(res.data)
//     console.log(res.data,"res.data33244");
    
//     setPageCount(res.data.length)
//   })
//   .catch(err=>{
//     setData([])
//     console.log(err)
//     dispatch(setSnackbar(true, "error", "No Data Found"));
//   })
// }

// function getSupplierData() {
//   axios
//     .get("/v1/outlet/list/1")
//     .then((res) => {
//       console.log(res.data)
//       setSupplier(res.data);
      
//       console.log( _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val)))
//       _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))

//     })
//     .catch((err) => {
//       dispatch(setSnackbar(true, "error", err.response.data.error));
//     });
// }
//  const handleFilterChange = (e) => {
//   const { name, value } = e.target;
//   setFilters(prev => ({ ...prev, [name]: value }));
// };
// useEffect(() => {
//   getSupplierData();
//   getSalesMan()
// }, []);
//   console.log(dateLimit)
//   useEffect(()=>{
//     if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
//       handlePaymentReport()
//     }
//   },[rowsPerPage, page, dateLimit,cust,custSalesMan,filters])
// //   const generateCSVData = () => {
// //     const csvData = [
// //       ["Outlet Name", cust !== null ? cust.fullname : fixedOutlet.fullname],
// //       ["From Date", moment(dateLimit.fromDate).format('YYYY-MM-DD')],
// //       ["To Date", moment(dateLimit.toDate).format('YYYY-MM-DD')],
// //       [],
// //       ["S.no", "Date", "Bill No", "Account Name", "Remarks", "Amount"]
// //     ];
  
// //     rows.forEach(row => {
// //       csvData.push([
// //         row.sno,
// //         row.date1,
// //         row.docNo,
// //         row.accName,
// //         row.remarks,
// //         row.amount
// //       ]);
// //     });
  
// //     csvData.push([]);
  
// //     csvData.push(["", "", "", "", "Total Amount", totalAmount]);
  
// //     return csvData;
// //   };

// const generateCSVData = () => {
//     const csvData = [
//     //   ["Outlet Name", cust !== null ? cust.fullname : fixedOutlet.fullname],
//     //   ["From Date", moment(dateLimit.fromDate).format('YYYY-MM-DD')],
//     //   ["To Date", moment(dateLimit.toDate).format('YYYY-MM-DD')],
//     //   [],
//       ["S.no", "code", "Short Name", "Outlet", "Sales Man Name", "Sales Man Code","Prod id","Product Name","Count","Rate","Total"]
//     ];
  
//     rows.forEach(row => {
//       csvData.push([
//         row.sno,
//         row.code,
//         row.short_name,
//         row.fullname,
//         row.sales_man_name,
//         row.sales_man_code,
//         row.prodid,
//         row.pro_name,
//         row.count,
//         row.rate,
//         row.total
//       ]);
//     });
  
//     csvData.push([]);
  
//     csvData.push(["", "", "", "", "","","","","","Total Amount", totalAmount]);
  
//     return csvData;
//   };
//   return (
//     <Fragment>
//       <Helmet><title>Sales Performance</title></Helmet>
//       <Typography variant="h6">Sales Performance</Typography>
//       <Grid container spacing={2} className="p-2 pt-2">
//         <Grid item md={2}>
//           <Autocomplete 
//               size="small"
//               value={cust}
//               options={supplier}
//               onChange={(e,value)=>setCust(value)}
//               getOptionLabel={option=>option.fullname}
//               disabled={(roleId != 1 && roleId != 2)} 
//               renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
//           />
//         </Grid>
//         <Grid item md={2}>
//           <Autocomplete
//                   size="small"
//                     options={salesManData}
//                     getOptionLabel={(option) => option.sales_man_name || ""}
//                     value={custSalesMan}
//                     onChange={(e, newValue) => setCustSalesMan(newValue)}
//                     renderInput={(params) => <TextField {...params} label="Select Salesman" variant="outlined" />}
//                   />
//         </Grid>
       
//         <Grid item md={2}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               // disabled={roleId != 1 && roleId != 2} 
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'From',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//         <Grid item md={2}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               // disabled={roleId != 1 && roleId != 2} 
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'To',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>

//         </Grid>
//           <Grid item md={1.5} >
//           <TextField  
//             size="small"
//             type="number"
//             label="Price From"
//             name="price_from"
//                          sx={{ width:"130px" }}

//             value={filters.price_from}
//             inputProps={{ min: 0, }}
//             // onChange={(e) => {
//             //   let value = e.target.value;
//             //   if (value === '') {
//             //     handleFilterChange(e);
//             //   } else if (Number(value) >= 0 && Number(value) <= 100) {
//             //     handleFilterChange(e);
//             //   }
//             // }}
//             onChange={handleFilterChange}
//           />
        
//         </Grid>
//           <Grid item md={1.5} >
       
          
//           <TextField
//             size="small"
//             type="number"
//             label="Price To"
//             name="price_to"
//              sx={{ pl: 1,width:"130px" }}
//             value={filters.price_to}
//             inputProps={{ min: 0 }}
//             // onChange={(e) => {
//             //   let value = e.target.value;
//             //   if (value === '') {
//             //     handleFilterChange(e);
//             //   } else if (Number(value) >= 0 && Number(value) <= 100) {
//             //     handleFilterChange(e);
//             //   }
//             // }}
//                         onChange={handleFilterChange}

//           />
//         </Grid>
//         <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}>
//           <CSVLink data={generateCSVData()} filename={"Sales-performance-report.csv"}>
//             <Button variant="contained" color="primary">
//               Download CSV
//             </Button>
//           </CSVLink>
//         </Grid>
//       </Grid>
//       <CustomTable props={props}/>
//     </Fragment>
//   );
// };

// export default memo(SalesPerformance);
import { Autocomplete, Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import { CSVLink } from "react-csv";
import Loader from "../../../../../components/loader/loader";
import { debounce } from "lodash";

const SalesPerformance = () => {
  const classes = useStyle()
   const codeRef = useRef(null)
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const roleId = localStorage.getItem("role_id")
  const outletName = localStorage.getItem('outlet_name')
  const[cust, setCust] = useState(null)
  const outletId = localStorage.getItem('outlet_id')
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const [loading , setLoading] = useState(false)
  const [dateLimit, setDateLimit] = useState({
    // fromDate : roleId != 1 && roleId != 2 ? moment().format() : moment().startOf('month').format(),
    
    fromDate :  moment().startOf('month').format(),
    toDate : moment().format()
  })
    const [salesManData, setSalesManData] = useState([]);
    const [custSalesMan, setCustSalesMan] = useState(null);
  const [filters, setFilters] = useState({
    price_from: '',
    price_to: '',
  });
   const [productData, setProductData] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(null);
     const [options, setOptions] = useState({
        customer : null,
        category : null,
        subCategory : null,
        type: null,
        head: null,
        product: null
    })
     const [search , setSearch] = useState('')
  const fixedOutlet = { id: outletId, fullname: outletName };
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
//   {
//     field: "date1",
//     headerName: "Date",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
  {
    field: "code",
    headerName: "code",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "short_name",
    headerName: "Short Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "fullname",
    headerName: "Outlet",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sales_man_name",
    headerName: "Sales Man Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sales_man_code",
    headerName: "Sales Man Code",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "prodid",
    headerName: "Prod id",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
{
    field: "pro_name",
    headerName: " Product Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
{
    field: "count",
    headerName: " Count",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
{
    field: "rate",
    headerName: "Rate",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
{
    field: "total",
    headerName: "Total",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },


 
]

const rows = _.map(data,(val,idx)=>({
  id: idx+1,
  sno: idx+1,
//   date1 : moment(val.docdate).format('DD-MM-YYYY'),
  code : val.code,
  fullname : val.fullname,
  short_name:val.short_name || "-",
  sales_man_name : val.sales_man_name || "-",
  sales_man_code: val.sales_man_code,
  prodid: val.prodid,
  pro_name: val.pro_name,
  count: val.count,
   rate: val.rate,
    total: val.total,

}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag,
  loading: loading
}
console.log(cust)
  const getSalesMan = (outletId) => {
    let endpoint = outletId && outletId !== 0 ? `/v1/SalesMan/outlets/${outletId}` : `/v1/SalesMan`; // Adjust for "All"
    axios
      .get(endpoint)
      .then((res) => {
        const salesmen = res.data;
        setSalesManData([{ id: 0, sales_man_name: "" }, ...salesmen]); // Add "All" option
      })
      .catch((err) =>
        dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching salesmen"))
      );
  };
  function getProductData() {
  const url = `/v1/outlet_item_filter/${outletId}`;
  const searchUrl = `/v1/outlet_item_filter/${outletId}/${search}`;

  axios.get(search === '' ? url : searchUrl)
    .then(res => {
      if (res.data.length > 0) {
        setProductData(res.data); // Set product data only if results are available
      }
    })
    .catch(err => {
      console.log("Error fetching product data:", err);
      dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
    });
}
useEffect(() => {
  getProductData();
}, [search]);

useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.total);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
function handlePaymentReport(){
//   const postData = {
//     from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
//     to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
//     outlet_id:cust!==null ? cust.id : fixedOutlet.id,
//     salesman_id: custSalesMan?.id || 0,
//   }
  const postData = {
  from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
  to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
  outlet_id: cust !== null ? cust.id : fixedOutlet.id,
  ...(custSalesMan?.id && { salesman_id: custSalesMan.id }) ,// only adds if exists
   ...(cust && cust.id !== 0 && { outlet_id: cust.id }),
  ...(filters.price_from && { price_from: filters.price_from }),
    ...(filters.price_to && { price_to: filters.price_to }),
      ...(options.product?.id && { product_id: options.product.id })
};

  console.log(postData)
  axios.post(`/v1/reports/sales/performance`, postData)
  .then(res=>{
    setData(res.data)
    console.log(res.data,"res.data33244");
    
    setPageCount(res.data.length)
  })
  .catch(err=>{
    setData([])
    setPageCount([])
    console.log(err)
    dispatch(setSnackbar(true, "error", "No Data Found"));
  })
}

// function getSupplierData() {
//   axios
//     .get("/v1/outlet/list/1")
//     .then((res) => {
//       console.log(res.data)
//       setSupplier(res.data);
      
//       console.log( _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val)))
//       _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))

//     })
//     .catch((err) => {
//       dispatch(setSnackbar(true, "error", err.response.data.error));
//     });
// }
function getSupplierData() {
  axios
    .get("/v1/outlet/list/1")
    .then((res) => {
      const allOption = { id: 0, fullname: "All" };
      const updatedList = [allOption, ...res.data];
      setSupplier(updatedList);

      // Auto-select current outlet if not already selected
      const matched = res.data.find(val => val.id == outletId);
      if (matched) setCust(matched);
    })
    .catch((err) => {
      dispatch(setSnackbar(true, "error", err.response.data.error));
    });
}

 const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({ ...prev, [name]: value }));
};
const handleInputChange = debounce((event, value) => {
  if (value.length > 2) {
    setSearch(value);  // Set search term for API call
  } else {
    setSearch('');  // Clear search when input is too short
    setProductData([]); // Clear product data to show no results
  }
},);  // Debounce delay of 300ms

 function handleOptions(value, name){
    console.log(name, value)
    setOptions(prev=>({...prev,[name] : value}))
    // if(name==='product'){
    //     codeRef.current.focus()
    // }
    if (name === 'product') {
      setSelectedProduct(value); // Save selected product details
      codeRef.current?.focus();
    }
}
useEffect(() => {
  getSupplierData();
  getSalesMan()
}, []);
  console.log(dateLimit)
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handlePaymentReport()
    }
  },[rowsPerPage, page, dateLimit,cust,custSalesMan,filters,options.product])
//   const generateCSVData = () => {
//     const csvData = [
//       ["Outlet Name", cust !== null ? cust.fullname : fixedOutlet.fullname],
//       ["From Date", moment(dateLimit.fromDate).format('YYYY-MM-DD')],
//       ["To Date", moment(dateLimit.toDate).format('YYYY-MM-DD')],
//       [],
//       ["S.no", "Date", "Bill No", "Account Name", "Remarks", "Amount"]
//     ];
  
//     rows.forEach(row => {
//       csvData.push([
//         row.sno,
//         row.date1,
//         row.docNo,
//         row.accName,
//         row.remarks,
//         row.amount
//       ]);
//     });
  
//     csvData.push([]);
  
//     csvData.push(["", "", "", "", "Total Amount", totalAmount]);
  
//     return csvData;
//   };

const generateCSVData = () => {
    const csvData = [
    //   ["Outlet Name", cust !== null ? cust.fullname : fixedOutlet.fullname],
    //   ["From Date", moment(dateLimit.fromDate).format('YYYY-MM-DD')],
    //   ["To Date", moment(dateLimit.toDate).format('YYYY-MM-DD')],
    //   [],
      ["S.no", "code", "Short Name", "Outlet", "Sales Man Name", "Sales Man Code","Prod id","Product Name","Count","Rate","Total"]
    ];
  
    rows.forEach(row => {
      csvData.push([
        row.sno,
        row.code,
        row.short_name,
        row.fullname,
        row.sales_man_name,
        row.sales_man_code,
        row.prodid,
        row.pro_name,
        row.count,
        row.rate,
        row.total
      ]);
    });
  
    csvData.push([]);
  
    csvData.push(["", "", "", "", "","","","","","Total Amount", totalAmount]);
  
    return csvData;
  };
  return (
    <Fragment>
      <Helmet><title>Sales Performance</title></Helmet>
      <Typography variant="h6">Sales Performance</Typography>
      <Grid container spacing={1.5} className="p-2 pt-2">
        <Grid item md={2.5}>
          <Autocomplete 
              size="small"
              value={cust}
              options={supplier}
              onChange={(e,value)=>setCust(value)}
              getOptionLabel={option=>option.fullname}
              disabled={(roleId != 1 && roleId != 2)} 
              renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={2.5}>
          <Autocomplete
                  size="small"
                    options={salesManData}
                    getOptionLabel={(option) => option.sales_man_name || ""}
                    value={custSalesMan}
                    onChange={(e, newValue) => setCustSalesMan(newValue)}
                    renderInput={(params) => <TextField {...params} label="Select Salesman" variant="outlined" />}
                  />
        </Grid>
         <Grid item md={2.5}>
         <Autocomplete
          size='small'
          options={productData}
          value={options.product}
          getOptionLabel={option => option.pro_name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(e, value) => handleOptions(value, 'product')}
          // onInputChange={handleInputChange} // Debounced input change
          onInputChange={(e, newInputValue) => handleInputChange(e, newInputValue)}
          renderInput={(params) => (
            <TextField {...params} label='Product List'/>
          )}
        />
       </Grid>
        <Grid item md={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              // disabled={roleId != 1 && roleId != 2} 
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              // disabled={roleId != 1 && roleId != 2} 
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>

        </Grid>
          <Grid item md={1.5} >
          <TextField  
            size="small"
            type="number"
            label="Price From"
            name="price_from"
                         sx={{ width:"130px" }}

            value={filters.price_from}
            inputProps={{ min: 0, }}
            // onChange={(e) => {
            //   let value = e.target.value;
            //   if (value === '') {
            //     handleFilterChange(e);
            //   } else if (Number(value) >= 0 && Number(value) <= 100) {
            //     handleFilterChange(e);
            //   }
            // }}
            onChange={handleFilterChange}
          />
        
        </Grid>
          <Grid item md={1.5}>
       
          
          <TextField
            size="small"
            type="number"
            label="Price To"
            name="price_to"
             sx={{ width:"130px" }}
            value={filters.price_to}
            inputProps={{ min: 0 }}
            // onChange={(e) => {
            //   let value = e.target.value;
            //   if (value === '') {
            //     handleFilterChange(e);
            //   } else if (Number(value) >= 0 && Number(value) <= 100) {
            //     handleFilterChange(e);
            //   }
            // }}
                        onChange={handleFilterChange}

          />
        </Grid>
        <Grid ml={2} item md={2} style={{ display: 'flex', alignItems: 'center' }}>
          <CSVLink data={generateCSVData()} filename={"Sales-performance-report.csv"}>
            <Button variant="contained" color="primary">
              Download CSV
            </Button>
          </CSVLink>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
    </Fragment>
  );
};

export default memo(SalesPerformance);